import { makeAutoObservable } from 'mobx';
import { IOsiServiceSaldoWidgetViewModel } from '@shared/types/mobx/widgets/OsiServiceSaldo';
import { getOsiSaldoByGroupsByOsiId } from '@shared/api/osi/saldoByGroups';
import { notifications } from '@shared/utils/notifications';
import logger from 'js-logger';
import { inject, injectable } from 'inversify';
import { ServiceGroupSaldoResponse } from '@shared/types/osi/saldoByGroups';
import { type OsiService, OsiServiceIdentifier } from '@shared/types/mobx/services/osi';
import { getBase64 } from '@shared/utils/helpers/base64Convertion';
import { loadSaldoFromExcel } from '@shared/api/osi';

@injectable()
export class OsiServiceSaldoWidgetViewModel implements IOsiServiceSaldoWidgetViewModel {
  saldoByGroup: ServiceGroupSaldoResponse[] = [];

  isLoading = false;

  constructor(@inject(OsiServiceIdentifier) private osiModule: OsiService) {
    makeAutoObservable(this);

    this.loadSaldoByGroup();
  }

  // Геттер osiId — нужен UI-кнопке загрузки сальдо и методу importSaldo.
  get osiId() {
    return this.osiModule.osiId;
  }

  // Загрузка начального сальдо из Excel для группы услуг groupId.
  // По образцу importAbonents: getBase64(file) → loadSaldoFromExcel → перезагрузка сальдо + нотификации.
  importSaldo = async (groupId: number, file: File) => {
    try {
      if (!this.osiId) throw new Error('OsiId is undefined');
      this.isLoading = true;
      const b64 = await getBase64(file);
      await loadSaldoFromExcel(this.osiId, groupId, b64.bytes);
      // Успех — перечитываем сальдо, чтобы таблицы групп отобразили загруженные значения.
      await this.loadSaldoByGroup();
      notifications.success();
    } catch (e) {
      logger.error(e);
      // Пробрасываем ошибку бэка в нотификацию (как в importAbonents).
      notifications.error(e);
    } finally {
      this.isLoading = false;
    }
  };

  private async loadSaldoByGroup() {
    try {
      if (!this.osiModule.osiId) {
        throw new Error('OsiId is undefined');
      }
      this.isLoading = true;
      this.saldoByGroup = await getOsiSaldoByGroupsByOsiId(this.osiModule.osiId);
    } catch (e) {
      logger.error(e);
      notifications.error();
    } finally {
      this.isLoading = false;
    }
  }
}
